import { Address } from '../../../types'

interface AddressProps {
    address: Address;
}

const AddressComponent = ({address}: AddressProps) =>
    <div>
        {address.DisplayLine1 && <div>{address.DisplayLine1}</div>}
        {address.CustomerName && <div>{address.CustomerName}</div>}
        {address.DisplayLine2 && <div>{address.DisplayLine2}</div>}
        {address.DisplayLine3 && <div>{address.DisplayLine3}</div>}
        {address.DisplayLine4 && <div>{address.DisplayLine4}</div>}
    </div>

export default AddressComponent;